import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {Router} from '@angular/router';
import {Injectable} from '@angular/core';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {GenericConfirmDialogComponent} from './generic-confirm-dialog/generic-confirm-dialog.component';
import {Utils} from '../../classes/utils';

@Injectable({
  providedIn: 'root'
})
export class HttpErrorInterceptor implements HttpInterceptor {

  constructor(private router: Router,
		private dialog: MatDialog) {}

  utils: Utils = new Utils();

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.status === 404) {
            // this.router.navigate(['/xxxxxxxxxxx']).then();
          }
          else {
            const config: MatDialogConfig = this.utils.getGenericDialogConfigWithoutData();
            config.data = {
              title: 'Errore con Codice ' + error.status,
              content: error.error.message || error.error.error,
              textButtonTwo: 'OK',
            };
            this.dialog.open(GenericConfirmDialogComponent, config);
          }
          return throwError(error);
        }));
  }
}
